(function () {
	'use strict';

	angular
		.module('app.notes')
		.factory('notesDialog', notesDialog);

	notesDialog.$inject = ['$uibModal', '$templateCache', 'opsIncludeVersion'];

	/* @ngInject */
	function notesDialog($modal, $templateCache, opsIncludeVersion) {
		var service = {
			show: show
		};

		return service;

		function show(title, includeTemplate, scopeItem) {
			var modalOptions = {
				ariaLabelledBy: "labelby",
				templateUrl: "app/dialogs/_modalTemplateDialog.html?v=" + opsIncludeVersion,
				controller: ModalInstance,
				controllerAs: 'vm',
				keyboard: true,
				resolve: {
					options: function () {
						return {
							title: title,
							item: scopeItem,
							includeTemplate: includeTemplate,
							okText: "Close"
						};
					}
				}
			};

			return $modal.open(modalOptions).result;
		}
	}

	ModalInstance.$inject = ['$uibModalInstance', 'options', 'dataservice', 'common', 'config', 'attachmentService', '$timeout'];

	/* @ngInject */
	function ModalInstance($modalInstance, options, dataservice, common, config, attachmentService, $timeout) {

		var vm = this;
		vm.notesForm = {}
		vm.item = options.item || {};
		vm.isSaving = false;
		vm.title = options.title || 'Title';
		vm.okText = options.okText || 'OK';
		vm.cancelText = options.cancelText || 'Cancel';
		vm.includeTemplate = options.includeTemplate;
		vm.updateNote = updateNote;
		vm.newNote = newNote;
		vm.deleteNote = deleteNote;
		vm.editNote = editNote;
		vm.cancelEdit = cancelEdit;
		vm.editingNoteId = -1;
		vm.deletingNoteId = -1;
		vm.deletingAttachmentId = -1;
		vm.deleteAttachment = deleteAttachment;
		vm.canEdit = canEdit;
		vm.canDelete = canDelete;
		vm.opsIncludeVersion = common.opsIncludeVersion;

		vm.ok = function () {
			if (vm.item.NewNote && vm.item.NewNote.trim() !== "") {

				newNote();
			}
			else {
				var imgInput = document.getElementById("photo");
				var img = imgInput.files[0];

				if (img) {
					common.logger.error("You must enter a note with your attachment");
					return;
				}
			}
			$modalInstance.close('ok');
		};
		vm.cancel = function () {
			$modalInstance.dismiss('cancel');
		};

		function canEdit(n) {
			return n.CreatedById == common.userService.userId();
		}

		function canDelete(n) {
			return canEdit(n) || common.userService.userType() > 0;
		}

		function cancelEdit(n) {
			vm.editingNoteId = -1;
			n.Notes = vm.originalNote.Notes;
		}

		function editNote(n) {
			vm.editingNoteId = n.ID;
			vm.originalNote = angular.copy(n);
		}

		function updateNote(item) {
			var noteDto = {};
			noteDto.ID = item.ID;
			noteDto.BookingId = vm.item.BookingId;
			noteDto.TaskId = vm.item.TaskId;
			noteDto.Notes = item.Notes;

			var parentType = noteDto.BookingId > 0 ? "BookingNote" : "TaskNote";
			dataservice.saveItem('api/DailySetup/UpdateNote', noteDto).then(function (saveResult) {
				vm.isSaving = false;
				vm.editingNoteId = -1;
			}, function (error) { });
		}

		function deleteAttachment(id, n) {
			vm.deletingAttachmentId = -1;
			var atts = [];
			atts.push(id);
			attachmentService.remove(atts);

			//n.AttachmentId = 0;
			n.FileName = "";
			n.Base64Data = "";
			n.StoredFile = null;

		}

		function deleteNote(item) {

			var id = item.ID;
			var routePart = vm.item.BookingId > 0 ? "DeleteBookingNote" : "DeleteTaskNote";

			dataservice.deleteItem('api/DailySetup/' + routePart + '/' + id).then(function (saveResult) {
				vm.isSaving = false;
				vm.deletingNoteId = -1;
				$.each(vm.item.Notes, function (index, result) {
					if (result) {
						if (result["ID"] == id) {
							vm.item.Notes.splice(index, 1);
						}
					}
				})
			}, function (error) { });
		}

		function newNote() {
			if (!(vm.item.NewNote) || vm.item.NewNote.trim() === "") {
				return;
			}
			vm.isSaving = true;
			var noteDto = {};
			noteDto.BookingId = vm.item.BookingId;
			noteDto.TaskId = vm.item.TaskId;
			noteDto.Notes = vm.item.NewNote;
			noteDto.DisplayedOn = moment(common.getMainState("mainDate")).format("YYYYMMDD");

			var parentType = noteDto.BookingId > 0 ? "BookingNote" : "TaskNote";

			dataservice.saveItem('api/DailySetup/NewNote', noteDto).then(function (saveResult) {
				vm.isSaving = false;
				var savedNote = saveResult.data;
				attachmentService.upload(parentType, savedNote.ID, savedNote);

				$timeout(function () {
					var id = savedNote.ID;

					$.each(vm.item.Notes, function (index, result) {
						if (result) {

							if (result["ID"] == id) {
								vm.item.Notes[index].FileName = savedNote.FileName;
								vm.item.Notes[index].Base64Data = savedNote.Base64Data;
								vm.item.Notes[index].StoredFile = savedNote.Base64Data
								vm.item.Notes[index].HasAttachment = true;;
							}
						}
					})
				}, 1000);

				vm.item.NewNote = "";
                /*
				vm.item.Notes.push(savedNote)
				vm.item.Notes.sort(function (a, b) {
					a = new Date(a.DateAddedUtc);
					b = new Date(b.DateAddedUtc);
					return a > b ? -1 : a < b ? 1 : 0
				});*/
			}).catch(function (error) {
				$scope.vm = false;
			});

		}
	}
})();